// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2f3gX","title":"Info_title__w8Zd9","links":"Info_links__2LrJr","link":"Info_link__2HlJf","logo":"Info_logo__2Nypx"};